import _ from 'lodash';
import React, { createContext, useContext } from 'react';
import type { Location } from 'react-router-dom';
import { useLocation, useNavigationType } from 'react-router-dom';

const PreviousRouteContext = createContext<Location[]>([]);

export const PreviousRouteProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const updatedLocation = useLocation();
  const navigationType = useNavigationType();

  const [previousLocations, setPreviousLocations] = React.useState<Location[]>(
    [],
  );

  if (updatedLocation !== _.last(previousLocations)) {
    setPreviousLocations(
      navigationType === 'REPLACE'
        ? [...previousLocations.slice(0, -1), updatedLocation]
        : [...previousLocations, updatedLocation],
    );
  }

  return (
    <PreviousRouteContext.Provider value={previousLocations}>
      {children}
    </PreviousRouteContext.Provider>
  );
};

const usePreviousRoute = (
  predicate: (route: string) => boolean = () => true,
) => {
  const locations = useContext(PreviousRouteContext);

  for (let i = locations.length - 2; i >= 0; i -= 1) {
    const { pathname } = locations[i] || {};
    if (pathname && predicate(pathname)) {
      return pathname;
    }
  }

  return null;
};

export default usePreviousRoute;
